baseApp.directive('pieChart', function() {
    return {
        templateUrl: '/public/directives/charts/pieChart.html',
        scope: {
            piechartdataversion: "=",
            dataurl: "=",
//            aggregationConfig : "=",
            facets: "=",
            index: "=",
            dateField: "=",
            addFilter: "=",
            options: "=?",
            parsedata: "=",
            name: "@",
            fields: "=",
            titlefield: "@",
            searchfield: "@",
            valuefield: "@",
            action: "=",
            hidetable: "@",
            hidepie: "@",
            type: "=",
            valuetype: "@",
            paging: "=",
            search: "=",
            topnumber: "=?",
            innertable: "=?",
            datafilter: "=?",
            showothers: "@",
            afterupdate: "=?",
            selected: '=?',
            posupdate: '=',
            showlegend: '@',
            loader: '@',
            loading: "=?",
            useFacetsAsItems: "=?"
        },
        link: function($scope, el) {
            $scope.el = el[0];
        },
        controller: ["$scope", "$timeout", "$rootScope", function($scope, $timeout, $rootScope) {
            $scope.pieData = [];
            $scope.showOthersEl = false;

            var TOP_NUMBER = $scope.topnumber || 5;

            $scope.elid = "piechart" + Math.random();


            $scope.$watch("options", function(newVal){
                $scope.tableConfig.fromDate = ($scope.options && $scope.options.localFrom) ?  $scope.options.localFrom : Number($rootScope.dateRange.start);
                $scope.tableConfig.toDate = ($scope.options && $scope.options.localTo) ?$scope.options.localTo : Number($rootScope.dateRange.end);
            });

            $scope.$watch('tableConfig', function(newData, oldData) {
                if ($scope.tableConfig.items) {
                    $scope.setPieData($scope.tableConfig.items);
                }
            }, true);

            $scope.$watch('selected', function(newData, oldData) {
                $scope.tableConfig.selectedId = $scope.selected;
            });

            $scope.$watch('fields', function(newValue, oldValue){
                if (newValue && !_.isEqual(newValue, oldValue)) {
                    $scope.tableConfig.fields = $scope.fields;
                }
            });

            $scope.$watch('posupdate', function(){
                updateOthers();
            });

            $scope.setPieData = function(data){
                if(pieChart){
                    updateChart(data);
                }
            };

            var pieChart;

            angular.element(document).ready(function () {
                pieChart = AmCharts.makeChart($scope.elid, {
                    "type": "pie",
                    "theme": "new",
                    "dataProvider": $scope.data,
                    "valueField": $scope.valuefield,
                    "titleField": $scope.titlefield,
                    labelsEnabled: false,
                    fontFamily: 'Roboto',
                    addClassNames: true,
                    autoMargins: false,
                    marginTop: 0,
                    marginBottom: 0,
                    "innerRadius": '35%',
                    marginRight: 3,
                    pullOutRadius: 0,
                    colorField: "$color",
                    startAngle: 45,
                    "balloon": {
                        "fixedPosition": true,
                        maxWidth: '80'
                    },
                    listeners: [
                        {
                            event: "dataUpdated",
                            method: dataUpdated
                        }]
                });

                var firstRender = true;

                function dataUpdated(){
                    $timeout(function(){
                        updateOthers();
                        firstRender = false;
                    }, firstRender ? 500 : 50);
                }

            });

            function updateOthers(){
                if($scope.showOthersEl){
                    var $el = $($scope.el).find('.dashboard-pie-table');
                    var elHeight = $el.find('.cato-table-wrapper').first().outerHeight();
                    var targetPos = $el.find('.table-legend').last().position();
                    if(targetPos){
                        var $pieOthers = $('.pie-others').filter(function(index,item){return $(item).attr('id') === ("others-" + $scope.elid)});
                        $pieOthers.css({
                            top: -(elHeight - (targetPos.top + 3)),
                            left: targetPos.left + 5
                        });
                    }
                }
            }

            var otherIndex;

            function updateChart(data){
                if(!pieChart) {
                    $timeout(updateChart, data, 50);
                    return;
                }

                var othersData = _.findWhere(data, {id:"Others"});
                if(othersData){
                    othersData.$color = pieChart.colors[pieChart.color.length-1];
                    othersData.specialLabel = "Others";
                    if($scope.showlegend){
                        $scope.showOthersEl = true;
                        var $pieOthers = $('.pie-others').filter(function(index,item){return $(item).attr('id') === ("others-" + $scope.elid)}).find('.legend-item');
                        $pieOthers.css('backgroundColor', othersData.$color);

                        otherIndex = data.indexOf(othersData);
                    }
                }
                else {
                    $scope.showOthersEl = false;
                }

                pieChart.dataProvider = data;

                pieChart.validateData();
            }

            $scope.othersLegendClick = function(e){
                e.stopPropagation();

                var $el = $(e.target);
                if($el.hasClass('off')){
                    $el.removeClass('off');
                    pieChart.showSlice(otherIndex);
                }
                else {
                    $el.addClass('off');
                    pieChart.hideSlice(otherIndex);
                }
            };

            $scope.othersLegendMouseenter = function(){
                pieChart.rollOverSlice(otherIndex);
            };

            $scope.othersLegendMouseleve = function(){
                pieChart.rollOutSlice(otherIndex);
            };

            $scope.tableConfig = {
                showLoader: $scope.loader,
                dataURL : function() {
                    $scope.loading = true;
                    this.requestId = $scope.name + 'pie' + new Date().getTime();
                    return $scope.dataurl ? $scope.dataurl() : null;
                },
                parseData: $scope.parsedata,
                fields : $scope.fields,
                noAutoSelect: true,
                fixedLayout: true,
                deselect: true,
                defer:true,
                dateField: $scope.dateField,
                facets: $scope.facets,
                addFilter: $scope.addFilter,
                index: $scope.index,
                fromDate: ($scope.options && $scope.options.localFrom) ? $scope.options.localFrom : Number($rootScope.dateRange.start) ,
                toDate: ($scope.options && $scope.options.localTo) ? $scope.options.localTo : Number($rootScope.dateRange.end),
                titleSearch: $scope.name,
                type: $scope.valuetype,
                noSearch: !$scope.search,
                selectedId: $scope.selected,
                watchDate: true,
                noPaging: !$scope.paging,
                pageSize: $scope.paging ? TOP_NUMBER : false,
                sortField: $scope.valuefield,
                sortDir: "DESC",
                hideCheckboxes: true,
                hideFacets: true,
                useFacetsAsItems: $scope.useFacetsAsItems,
                expand  :true,
                innerTableParseData: ($scope.innertable && $scope.innertable.innerTableParseData) ? $scope.innertable.innerTableParseData : null,
                innerTableDataURL: ($scope.innertable && $scope.innertable.innerTableDataURL) ? $scope.innertable.innerTableDataURL : null,
                innerTable: $scope.innertable,
                expanderClick: $scope.innertable? function(){
                    $scope.innertable.expanderClick.call();
                    updateOthers();
                }: null,
                dataFilter: $scope.datafilter,
                showOthers: $scope.showothers,
                legend: $scope.showlegend,
                processData: function(items, data){
                    proccessItems(items, data);
                },
                afterUpdate: function(){
                    $scope.loading = false;
                    if($scope.afterupdate){
                        $scope.afterupdate.call(this);
                    }
                    $scope.$digest();
                },
                onSelect: function(index, row){
                    $scope.iteminfo = {};
                    if(index !== -1){
                        if($scope.action){
                            $scope.action(row);
                        }
                    }
                    else {
                        if($scope.action){
                            $scope.action(row);
                        }
                    }

                    $($scope.el).find('.legend-item').removeClass('off');
                }
            };

            function proccessItems(items, data){
                if(!pieChart){
                    $timeout(function(){
                        proccessItems(items, data);
                    }, 10, false);

                    return;
                }
                if (data.tooManyResults) {
                    $scope.$root.showNotification("error", "Partial results - Please select a smaller time range", "Partial results - Please select a smaller time range", true, false);
                }
                for(var i=0;items[i];i++){
                    items[i].legend = {
                        color: pieChart.colors[i],
                        click: (function(){
                            var index = i;
                            return function(e){
                                e.stopPropagation();

                                var $el = $(e.target);
                                if($el.hasClass('off')){
                                    $el.removeClass('off');
                                    pieChart.showSlice(index);
                                }
                                else {
                                    $el.addClass('off');
                                    pieChart.hideSlice(index);
                                }
                            };
                        })(),
                        mouseOver: (function(){
                            var index = i;
                            return function(e){
                                pieChart.rollOverSlice(index);
                            };
                        })(),
                        mouseOut: (function(){
                            var index = i;
                            return function(e){
                                pieChart.rollOutSlice(index);
                            };
                        })(),
                        shown: true
                    };
                }
            }
        }]
    };
});